import { useEffect, useState } from 'react';
import axios from 'axios';
import { Trophy, Sparkles } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const timeAgo = (iso) => {
    if (!iso) return '';
    const t = new Date(iso).getTime();
    const s = Math.floor((Date.now() - t) / 1000);
    if (s < 60) return `${s}s ago`;
    if (s < 3600) return `${Math.floor(s / 60)}m ago`;
    if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
    return `${Math.floor(s / 86400)}d ago`;
};

/**
 * Winners Wall — recent wheel winners for this player's operator.
 * Auto-hides when there are no winners in the last week. Meant to sit
 * right below the WheelWidget on the lobby so incoming players can see
 * "hey, Jimmy just won $25" and feel the FOMO on next $20 load.
 */
const WinnersWall = () => {
    const [rows, setRows] = useState([]);

    useEffect(() => {
        let alive = true;
        const load = async () => {
            try {
                const { data } = await axios.get(`${API}/wheels/winners?limit=5`, { withCredentials: true });
                if (!alive) return;
                setRows(Array.isArray(data) ? data : []);
            } catch { /* silent */ }
        };
        load();
        const t = setInterval(load, 60_000);
        return () => { alive = false; clearInterval(t); };
    }, []);

    if (rows.length === 0) return null;

    return (
        <div
            className="bg-[#0e0e0e] border border-[#FFD700]/25 rounded-2xl p-3"
            data-testid="winners-wall"
        >
            <div className="flex items-center gap-2 mb-2">
                <Trophy className="w-4 h-4 text-[#FFD700]" />
                <span className="text-xs uppercase tracking-wider font-bold text-[#FFD700]">
                    Recent wheel winners
                </span>
                <Sparkles className="w-3 h-3 text-[#FFD700]/60" />
            </div>
            <div className="flex gap-2 overflow-x-auto pb-1 -mx-1 px-1" style={{ scrollbarWidth: 'thin' }}>
                {rows.map((r) => (
                    <div
                        key={r.id}
                        className="shrink-0 min-w-[180px] bg-gradient-to-br from-[#FFD700]/10 to-transparent border border-[#FFD700]/30 rounded-xl px-3 py-2"
                        data-testid={`winner-card-${r.id}`}
                    >
                        <div className="text-xs font-bold text-white truncate">
                            {r.winner_name}
                        </div>
                        <div className="text-sm font-bold text-[#FFD700]">
                            +${r.prize_amount.toFixed(0)}
                        </div>
                        <div className="text-[10px] text-[#8891A0] mt-0.5 flex items-center justify-between gap-1">
                            <span className="truncate">{r.name}</span>
                            <span className="shrink-0">{timeAgo(r.fired_at)}</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default WinnersWall;
